import { render } from "./LikertComponent.vue?vue&type=template&id=360c970d"
import script from "./LikertComponent.vue?vue&type=script&lang=js"
export * from "./LikertComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__